import { useCallback, useState } from 'react';
import { captureSupabaseError } from '../lib/supabaseError';

import { axiosRubyClient } from '@/util/axios/axiosClient';

interface FindOrCreateResponse {
  success: boolean;
  data: { conversation_id: string };
  errors?: string[];
}

export function useFindOrCreateConversation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const open = useCallback(
    async (workerId: number, title?: string): Promise<string> => {
      setLoading(true);
      setError(null);
      try {
        const res = await axiosRubyClient.post<FindOrCreateResponse>(
          '/api/admin/conversations',
          { worker_id: workerId, title },
        );
        return res.data.data.conversation_id;
      } catch (err: unknown) {
        const message =
          (
            err as { response?: { data?: { errors?: string[] } } }
          )?.response?.data?.errors?.join(', ') ??
          (err as Error)?.message ??
          'Failed to open conversation';
        captureSupabaseError(err, {
          action: 'find_or_create_conversation',
          extra: { worker_id: workerId },
        });
        setError(message);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { open, loading, error };
}
